import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import ProfileCard from "@/components/ProfileCard";

export default function Shortlist() {
  const [profiles, setProfiles] = useState([]);
  useEffect(() => {
    (async () => {
      const { data } = await api.get("/shortlist");
      setProfiles(data.profiles || []);
    })();
  }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-10" data-testid="shortlist-page">
      <div className="label-eyebrow text-brand-terracotta">Curated by you</div>
      <h1 className="font-serif text-5xl md:text-6xl tracking-tighter mt-2 text-brand-ink">Shortlist</h1>
      <p className="mt-3 text-brand-muted">{profiles.length} profile{profiles.length === 1 ? "" : "s"} you're keeping an eye on</p>

      <div className="mt-8">
        {profiles.length === 0 ? (
          <div className="border border-dashed border-brand-line p-16 text-center text-brand-muted" data-testid="shortlist-empty">
            You haven't shortlisted anyone yet.
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {profiles.map((p) => <ProfileCard key={p.id} profile={p} />)}
          </div>
        )}
      </div>
    </div>
  );
}
